import React, { useRef } from 'react';
import { Shield, DollarSign, Link2, Sparkles } from 'lucide-react';
import { TEAM_COLOR, CREW } from './rtbBoard';

const CREW_ICON = { enforcer: Shield, earner: DollarSign, connector: Link2, wildcard: Sparkles };

export function RtbFigure({ team, idx, pos, cell, big = 1, movable, active, onClick }) {
  const prev = useRef(pos);
  const durRef = useRef(230);
  const dist = Math.hypot(pos.x - prev.current.x, pos.y - prev.current.y);
  if (dist > 0) durRef.current = dist > cell * 1.8 ? 700 : 230;
  prev.current = pos;
  const dur = durRef.current;
  const col = TEAM_COLOR[team];
  const h = cell * 2.05 * big * pos.s;
  const crew = CREW[idx];
  const Icon = CREW_ICON[crew];
  const bw = cell * 0.95 * (big > 1 ? 1.45 : 1) * pos.s;
  return (
    <div className="absolute left-0 top-0" style={{
      transform: `translate(${pos.x}px, ${pos.y}px)`,
      transition: `transform ${dur}ms cubic-bezier(.3,.7,.4,1)`,
      zIndex: Math.round(pos.y) + (active ? 1 : 0),
      willChange: 'transform',
    }}>
    <button
      type="button"
      data-testid={`rtb-piece-${team}-${idx}`}
      aria-label={`${team} ${crew}${movable ? ' — tap to move' : ''}`}
      disabled={!movable}
      onClick={onClick}
      className="absolute p-0 border-0 bg-transparent"
      style={{ left: -bw / 2, top: -h, width: bw, height: h + cell * 0.2 * pos.s, cursor: movable ? 'pointer' : 'default', pointerEvents: movable ? 'auto' : 'none' }}
    >
    <div className="absolute" style={{ left: bw / 2, top: h }}>
      <div className="absolute rounded-full"
        style={{
          width: cell * 0.9 * pos.s, height: cell * 0.42 * pos.s, left: -cell * 0.45 * pos.s, top: -cell * 0.21 * pos.s,
          background: `radial-gradient(ellipse, ${col}cc 0%, ${col}55 55%, transparent 72%)`,
          boxShadow: movable ? `0 0 0 2px #FDE68A, 0 0 18px #FDE68A` : `0 0 10px ${col}`,
        }}
        {...(movable ? { 'data-movable': 'true' } : {})}
      />
      {movable && <div className="rtb-pulse absolute rounded-full" style={{ width: cell * 1.1 * pos.s, height: cell * 0.55 * pos.s, left: -cell * 0.55 * pos.s, top: -cell * 0.27 * pos.s }} />}
      <img src={`/rtb/crew/${team}_${crew}.png`} alt="" draggable={false}
        className={`absolute pointer-events-none select-none ${movable ? 'rtb-bob' : ''}`}
        style={{ height: h, width: 'auto', maxWidth: 'none', left: '50%', bottom: 0, transform: 'translateX(-50%)', filter: `drop-shadow(0 4px 4px rgba(0,0,0,.8)) drop-shadow(0 0 3px ${col})` }} />
      <span className="absolute flex items-center justify-center rounded-full"
        style={{ width: cell * 0.36 * pos.s, height: cell * 0.36 * pos.s, left: cell * 0.18 * pos.s, top: -cell * 0.62 * pos.s, background: '#0b0b0f', border: `1.5px solid ${col}` }}>
        <Icon size={cell * 0.22 * pos.s} color={col} strokeWidth={2.6} />
      </span>
    </div>
    </button>
    </div>
  );
}
